"use client";

import { usePathname } from "@holibob-packages/ui-core/navigation";

export const useIsBookingPage = () => {
    const pathname = usePathname();
    return pathname.startsWith("/booking");
};
